import getUrls from "../api";
import BaseDataService from "./base-data-service";

class AppService extends BaseDataService {
    reqCloseApp = async () => {
        let url = new URL(this.uri.baseUrl);
        fetch(url + "Close").then(resp => {
            if (resp.ok) {
                return;
            }
            throw new Error("ERROR. Couldn't close app");
        });
    };
}

const prepareAppService = basepath => {
    const { originPath } = getUrls(basepath);
    let baseUrl = originPath + "api/app/";
    // Signal service_________________________
    let signalService;
    signalService = new AppService(baseUrl);

    return signalService;
};
export default prepareAppService;
